// src/services/newCategoryService.js
import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);

// Lấy tất cả danh mục tin tức với pagination và filter
export const getNewCategories = async (params = {}) => {
  try {
    const response = await apiClient.get("/newCategory", { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching new categories:', error);
    throw error;
  }
};

// Lấy danh mục tin tức theo ID
export const getNewCategoryById = async (id) => {
  try {
    const response = await apiClient.get(`/newCategory/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching new category:', error);
    throw error;
  }
};

// Lấy danh mục tin tức theo slug
export const getNewCategoryBySlug = async (slug) => {
  try {
    const response = await apiClient.get(`/newCategory/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching new category by slug:', error);
    throw error;
  }
};

// Tạo danh mục tin tức mới (admin only)
export const createNewCategory = async (categoryData) => {
  try {
    const response = await apiClient.post('/newCategory', categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating new category:', error);
    throw error;
  }
};

// Cập nhật danh mục tin tức (admin only)
export const updateNewCategory = async (id, categoryData) => {
  try {
    const response = await apiClient.put(`/newCategory/${id}`, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating new category:', error);
    throw error;
  }
};

// Xóa danh mục tin tức (admin only)
export const deleteNewCategory = async (id) => {
  try {
    const response = await apiClient.delete(`/newCategory/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting new category:', error);
    throw error;
  }
};
